<template>

  <div class="advertiser-container">
    <div>经销商管理用户---(经销商代码:{{distributorCode}})</div>
    <!-- <el-form inline :model="searchForm" label-width="140px" style="margin-top: 30px;">
      <el-form-item label="最终用户关键字">
        <el-input v-model="searchForm.finalUserKey" autocomplete="off"></el-input>
      </el-form-item>
      <el-button @click="onSearch" type="primary">搜索</el-button>
    </el-form> -->
    <right-back/>
    
    <el-table 
      :data="finalUserList" 
      border :header-cell-style="{background:'#eef1f6',color:'#606266'}"  height="750"
			style="width: 80%;margin-top: 10px;" ref="Table" >
      <!-- <el-table-column prop="distributorCode" align="center" label="分公司" ></el-table-column>
      <el-table-column prop="distributorName" align="center" label="经销商代码" ></el-table-column>
      <el-table-column prop="distributorFullName" align="center" label="经销商帐号"></el-table-column>
      <el-table-column prop="businessWindow" align="center" label="经销商" ></el-table-column>
      <el-table-column prop="stopUse" align="center" label="经销商名称" ></el-table-column>
      <el-table-column prop="finalUserCode" align="center" label="MPN ID" ></el-table-column>
      <el-table-column prop="finalUserName" align="center" label="业务窗口" ></el-table-column>
      <el-table-column prop="creditCode" align="center" label="可下单" ></el-table-column>
      <el-table-column prop="finalUserFullName" align="center" label="帐号启用" ></el-table-column>
      <el-table-column prop="country" align="center" label="電子郵件" ></el-table-column>
      <el-table-column prop="postcode" align="center" label="统一社会信用代码/纳税人识别号" ></el-table-column>
      <el-table-column prop="city" align="center" label="公司负责人" ></el-table-column>
      <el-table-column prop="province" align="center" label="电话" ></el-table-column>
      <el-table-column prop="address1" align="center" label="传真" ></el-table-column>
      <el-table-column prop="address2" align="center" label="联络手机" ></el-table-column>
      <el-table-column prop="userFirstName" align="center" label="地址" ></el-table-column>
      <el-table-column prop="userLastName" align="center" label="联络人" ></el-table-column>
      <el-table-column prop="email" align="center" label="付款条件" ></el-table-column>
      <el-table-column prop="tel" align="center" label="帐信状态" ></el-table-column>
      <el-table-column prop="stopOld" align="center" label="授信总额度" ></el-table-column>
      <el-table-column prop="account" align="center" label="常态额度" ></el-table-column>
      <el-table-column prop="accountId" align="center" label="临时额度" ></el-table-column> -->
      <el-table-column prop="finalUserCode" align="center" label="终端客户代码" ></el-table-column>
      <el-table-column prop="finalUserFullName" align="center" label="公司全名" ></el-table-column>
      <el-table-column prop="stopUse" align="center" label="终端客户停用" ></el-table-column>
      <el-table-column prop="creditCode" align="center" label="统一社会信用代码/纳税人识别号" ></el-table-column>
      <el-table-column prop="country" align="center" label="国家" ></el-table-column>
      <el-table-column prop="province" align="center" label="省/市" ></el-table-column>
      <el-table-column prop="city" align="center" label="城市" ></el-table-column>      
      <el-table-column prop="postcode" align="center" label="邮政编码" ></el-table-column>
      <el-table-column prop="address1" align="center" label="通讯地址 1" ></el-table-column>
      <el-table-column prop="address2" align="center" label="通讯地址 2" ></el-table-column>
      <el-table-column prop="userFirstName" align="center" label="主要联络人-姓" ></el-table-column>
      <el-table-column prop="userLastName" align="center" label="主要联络人-名字" ></el-table-column>
      <el-table-column prop="email" align="center" label="主要联络人-电子邮件" ></el-table-column>
      <el-table-column prop="tel" align="center" label="主要联络人-电话" ></el-table-column>
      <el-table-column prop="stopOld" align="center" label="原厂帐号停用" ></el-table-column>
      <el-table-column prop="account" align="center" label="原厂帐号" ></el-table-column>
      <el-table-column prop="accountId" align="center" label="帐号ID" ></el-table-column>


      <!--  -->
      <el-table-column prop="distributorCode" align="center" label="经销商代码" ></el-table-column>
      <!-- <el-table-column prop="distributorName" align="center" label="" ></el-table-column> -->
      <el-table-column prop="distributorFullName" align="center" label="经销商名称"></el-table-column>
      <el-table-column prop="businessWindow" align="center" label="业务窗口" ></el-table-column>
      <!-- <el-table-column prop="stopUse" align="center" label="经销商名称" ></el-table-column> -->

        
      <!-- <el-table-column  align="center" label="操作" fixed="right">
        <template slot-scope="scope">
            <el-button type="primary" size="small"  @click.native.prevent="onItemEditClick(scope.row)">查看</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- <div class="tabListPage">
           <el-pagination @size-change="handleSizeChange" 
                          @current-change="handleCurrentChange" 
                          :current-page="currentPage" 
                          :page-sizes="pageSizes" 
                          :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                          :total="totalCount">
             </el-pagination>
       </div> -->

  </div>
</template>

<script>

import CommonTable from "@/components/CommonTable";
import {getLatestMonthDateArrayByDate} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";
import RightBack from "@/components/RightBack";
// import {setFinish} from "@/api/workSheet";

export default {
  name: "Advertiser",
  components: { RightBack,CommonTable}, 
  computed: { ...mapGetters(["finalUserList"]) },
  props: ['distributorCode'],
  data() {
    return {
      editOrderDialogVisible: false,
      searchForm: {
        distributorKey: "",
        finalUserKey:"",
      },
      currentItem: {},
      
      // 默认显示第几页
           currentPage:1,
           // 总条数，根据接口获取数据长度(注意：这里不能为空)
           totalCount:0,
           // 个数选择器（可修改）
           pageSizes:[20,50,100],
           // 默认每页显示的条数（可修改）
           PageSize:50,

    };
  },
 

  async created() {
    // this.onSearch();
  },

  async mounted() {
    this.onSearch();
  },

  methods: {    

    // // 分页
    //     // 每页显示的条数
    //    handleSizeChange(val) {
    //        // 改变每页显示的条数 
    //        this.PageSize=val
    //        // 注意：在改变每页显示的条数时，要将页码显示到第一页
    //        this.currentPage=1
    //    },
    //      // 显示第几页
    //    handleCurrentChange(val) {
    //        // 改变默认的页数
    //        this.currentPage=val
    //    },

 

    async onSearch() {
      await this.$store.dispatch("bd/finalUserListSet", {
        finalUserKey:'',
        distributorCode:this.distributorCode,
      }).then(res=>{
          this.$refs.Table.doLayout();
          this.totalCount=this.finalUserList.length
          console.log('this.finalUserList',this.finalUserList)
          this.currentPage=1
      });


    },


  },
};
</script>

<style scoped>

</style>